import NewsletterSubscriptionQuery from 'Query/NewsletterSubscription.query';
import {
    NewsletterSubscriptionDispatcher as SourceNewsletterSubscriptionDispatcher,
    NOT_ACTIVE as SOURCE_NOT_ACTIVE
} from 'SourceStore/NewsletterSubscription/NewsletterSubscription.dispatcher';
import { showNotification } from 'Store/Notification/Notification.action';
import { fetchMutation, getErrorMessage } from 'Util/Request';

export const NOT_ACTIVE = SOURCE_NOT_ACTIVE;

/** @namespace Bodypwa/Store/NewsletterSubscription/Dispatcher */
export class NewsletterSubscriptionDispatcher extends SourceNewsletterSubscriptionDispatcher {
    // TODO implement logic
    subscribeToNewsletter(dispatch, email, noNotification = false) {
        return fetchMutation(NewsletterSubscriptionQuery.getSubscribeToNewsletterMutation(email)).then(
            /** @namespace Bodypwa/Store/NewsletterSubscription/Dispatcher/NewsletterSubscriptionDispatcher/subscribeToNewsletter/fetchMutation/then */
            ({ subscribeEmailToNewsletter: { status } }) => {
                // `NOT_ACTIVE` response status corresponds to `newsletter_subscription_confirm` magento setting
                const message = status === NOT_ACTIVE
                    ? __('Confirmation request has been sent.')
                    : __('Thank you for your subscription.');

                return noNotification ? true : dispatch(showNotification('success', message));
            },
            /** @namespace Bodypwa/Store/NewsletterSubscription/Dispatcher/NewsletterSubscriptionDispatcher/subscribeToNewsletter/fetchMutation/then/catch */
            (error) => (noNotification ? false : dispatch(showNotification('error', getErrorMessage(error))))
        );
    }
}

export default new NewsletterSubscriptionDispatcher();
